import { Age, Price } from "../shared";

// categoryはactivityでもつので不要とする。
export interface CategoryGroup {
	price?: Price; //labelは選択肢表示用（人口分布差し替え時に、旧選択肢を表示するために使用）
	age: Age;
	appearance: number; //出現率
	// ユーザーかノンユーザーかはシステムで使用しないのでDBに登録しない
}
